import { Grid, Select, Space, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { useEffect } from 'react';
import { cities, provinces } from '../../../../data/province-city.array';
import { Countries } from '../../../../enums/countries.enum';
import { CreateBranchDetailsForm } from '../../../../type/entity.types';
import {
  EntityFilterData,
  EntityIdFilterData,
} from '../../../../type/filter.types';
import SelectMerchantFilter from '../../../filters/select-merchant-filter.component';
import SelectPartnerFilter from '../../../filters/select-partner-filter.component';
import SelectResellerFilter from '../../../filters/select-reseller-filter.component';
import PhoneCountryCodeIcon from '../../../icons/phone-country-code-icon.component';
import XCol4 from '../../../x-components/grid-col/x-col-4.component';
import XCol6 from '../../../x-components/grid-col/x-col-6.component';

function BranchDetails(props: Props) {
  const { form, isAdmin } = props;

  const filterData = useForm<EntityFilterData>({
    initialValues: {
      partnersData: [],
      resellersData: [],
      merchantsData: [],
    },
  });
  const filterValues = useForm<EntityIdFilterData>({
    initialValues: {
      partner: undefined,
      reseller: undefined,
      merchant: undefined,
    },
  });

  useEffect(() => {
    form.setFieldValue('partnerId', filterValues.values.partner);
    form.setFieldValue('resellerId', filterValues.values.reseller);
    form.setFieldValue('merchantId', filterValues.values.merchant);
  }, [filterValues.values]);

  return (
    <>
      <Text size='xl' weight={700}>
        Merchant Branch Details
      </Text>
      <Space h='xl' />
      <Grid>
        {isAdmin && (
          <>
            <XCol6>
              <SelectPartnerFilter
                filterSelectData={filterData}
                filterValues={filterValues}
                error={form.errors.partnerId}
              />
            </XCol6>
            <XCol6>
              <SelectResellerFilter
                filterSelectData={filterData}
                filterValues={filterValues}
                isPartnerDependent={true}
                error={form.errors.resellerId}
              />
            </XCol6>
          </>
        )}

        <XCol6>
          <SelectMerchantFilter
            filterSelectData={filterData}
            filterValues={filterValues}
            isResellerDependent={isAdmin}
            error={form.errors.merchantId}
          />
        </XCol6>
        <XCol6></XCol6>

        <Grid.Col span={12}>
          <TextInput
            label={labels.entityName}
            placeholder={placeholders.entityName}
            {...form.getInputProps('entityName')}
          />
        </Grid.Col>

        <Grid.Col span={12}>
          <TextInput
            label={labels.bldgNameNo}
            placeholder={placeholders.bldgNameNo}
            {...form.getInputProps('buildingNameAndNumber')}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label={labels.line1}
            placeholder={placeholders.line1}
            {...form.getInputProps('line1')}
          />
        </Grid.Col>
        <XCol6>
          <Select
            label={labels.province}
            placeholder={placeholders.province}
            data={provinces}
            value={form.values.state}
            onChange={(value: string) => {
              form.setFieldValue('state', value);
              form.setFieldValue('city', '');
            }}
            searchable
            nothingFound='No options'
            error={form.errors.state}
          />
        </XCol6>
        <XCol6>
          <Select
            label={labels.city}
            placeholder={placeholders.city}
            data={form.values.state.length > 0 ? cities[form.values.state] : []}
            disabled={form.values.state === ''}
            searchable
            nothingFound='No options'
            value={form.values.city}
            onChange={(value: string) => {
              form.setFieldValue('city', value);
            }}
            error={form.errors.city}
          />
        </XCol6>
        <XCol4>
          <TextInput
            label={labels.barangay}
            placeholder={placeholders.barangay}
            {...form.getInputProps('barangay')}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.postalCode}
            placeholder={placeholders.postalCode}
            {...form.getInputProps('postalCode')}
          />
        </XCol4>
        <XCol4>
          <Select
            label={labels.country}
            placeholder={placeholders.country}
            data={[
              {
                label: 'Philippines',
                value: Countries.PHILIPPINES.toString(),
              },
            ]}
            value={form.values.countryId.toString()}
            onChange={(value: string) => {
              form.setFieldValue('countryId', parseInt(value));
            }}
            error={form.errors.countryId}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.primary}
            placeholder={placeholders.primary}
            icon={<PhoneCountryCodeIcon />}
            iconWidth={48}
            {...form.getInputProps('primary')}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.fax}
            placeholder={placeholders.fax}
            {...form.getInputProps('fax')}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.mobile}
            placeholder={placeholders.mobile}
            icon={<PhoneCountryCodeIcon />}
            iconWidth={48}
            {...form.getInputProps('mobile')}
          />
        </XCol4>
      </Grid>
    </>
  );
}

export default BranchDetails;

interface Props {
  form: UseFormReturnType<CreateBranchDetailsForm>;
  isAdmin: boolean;
}

const labels = {
  entityName: 'Branch name',
  emailAddress: 'Merchant email',

  bldgNameNo: 'Building name and number',
  line1: 'Street address',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  country: 'Country',
  primary: 'Primary contact number',
  fax: 'FAX',
  barangay: 'Barangay',
  mobile: 'Mobile phone number',
};
const placeholders = {
  entityName: 'Branch name',
  emailAddress: 'Merchant email',

  bldgNameNo: 'Building name and number',
  line1: 'Street address',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  country: 'Country',
  primary: 'Primary contact number',
  fax: 'FAX',
  barangay: 'Barangay',
  mobile: 'Mobile phone number',
};
